import FetchStatusRepository  from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository       from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import CurrentPage            from "../../../../domain/fundamentals/pagination/CurrentPage";
import MailTemplateId         from "../../../../domain/mail/template/MailTemplateId";
import MailTemplateRepository from "../../../../domain/mail/template/MailTemplateRepository";
import FetchStatusDataSource  from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import MailTemplateDataSource from "../../../../infrastructure/datasource/mail/template/MailTemplateDataSource";
import NotifyDataSource       from "../../../../infrastructure/datasource/notify/NotifyDataSource";
import GetMailTemplates       from "./GetMailTemplates";

class DeleteMailTemplate {
  private readonly mailTemplateRepository: MailTemplateRepository = new MailTemplateDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);
  private readonly getMailTemplates: GetMailTemplates = new GetMailTemplates(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(mailTemplateId: MailTemplateId) {
    this.fetchStatusRepository.start();
    try {
      await this.mailTemplateRepository.delete(mailTemplateId);
      await this.getMailTemplates.execute(new CurrentPage());
      this.notifyRepository.deleteSuccess();
    } catch (e) {
      this.notifyRepository.deleteFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default DeleteMailTemplate;
